module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASBAMAAACp/uMjAAAAFVBMVEVHcEyHh4eHh4eHh4eGhoaFhYWHh4dcY8ygAAAABnRSTlMA7yCPf4DLZkIFAAAAO0lEQVQI12NgYEgDAwYQIMiEAxYxiGiiAYNZGhSkMkAF05QSGWCCSmlwZho6E2o4DiaQZIARKExMlwEA+yotCrdgAI4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/print.png
// module id = 9843
// module chunks = 23